{
    "up.common.cancel": "Cancelar",
    "up.common.confirm": "Confirmar",
    "up.common.start": "Iniciar",
    "up.common.end": "Finalizar",
    "up.common.stop": "Detener",
    "up.common.copy": "Copiar",
    "up.common.none": "Ninguno",
    "up.common.tip": "Consejo",
    "up.common.success": "Éxito",
    "up.common.fail": "Fallido",
    "up.common.close": "Cerrar",
    "up.common.preview": "Vista previa",
    "up.common.re-select": "Re seleccionar",
    "up.common.rotate": "Rotar",
    "up.common.pleaseChoose": "Por favor seleccione",
    "up.common.loading": "Cargando",
    "up.common.loading2": "Cargando",
    "up.common.inOperation": "En operación",
    "up.common.settings": "Configuración",
    "up.common.retry": "Reintentar",
    "up.common.search": "Buscar",
    "up.common.more": "Más",
    "up.common.video": "Vídeo",
    "up.common.file": "Archivo",
    "up.week.one": "Lun",
    "up.week.two": "Mar",
    "up.week.three": "Mié",
    "up.week.four": "Jue",
    "up.week.five": "Vie",
    "up.week.six": "Sáb",
    "up.week.seven": "Dom",
    "up.barcode.error": "Error al generar código de barras",
    "up.calendar.chooseDates": "Selección de fecha",
    "up.calendar.disabled": "Esta fecha está deshabilitada",
    "up.calendar.daysExceed": "Los días seleccionados no pueden exceder {days} días",
    "up.cityLocate.locateCity": "Localizar ciudad",
    "up.cityLocate.fail": "Error de localización, haga clic para reintentar.",
    "up.cityLocate.locating": "Localizando",
    "up.code.send": "Obtener código de verificación",
    "up.code.resendAfter": "Reenviar en X segundos",
    "up.code.resend": "Reenviar",
    "up.cropper.emptyWidhtOrHeight": "El ancho o alto del recorte no está configurado",
    "up.empty.car": "Carrito de compras vacío",
    "up.empty.page": "Página no encontrada",
    "up.empty.search": "Sin resultados de búsqueda",
    "up.empty.address": "Sin dirección de envío",
    "up.empty.wifi": "Sin WiFi",
    "up.empty.order": "Pedido vacío",
    "up.empty.coupon": "Sin cupones",
    "up.empty.favor": "Sin favoritos",
    "up.empty.permission": "Sin permisos",
    "up.empty.history": "Sin historial",
    "up.empty.news": "Sin noticias",
    "up.empty.message": "Lista de mensajes vacía",
    "up.empty.list": "Lista vacía",
    "up.empty.data": "Datos vacíos",
    "up.empty.comment": "Sin comentarios",
    "up.link.copyed": "Enlace copiado, por favor abra en el navegador",
    "up.loadmoe.loadmore": "Cargar más",
    "up.loadmoe.nomore": "No hay más",
    "up.noNetwork.text": "¡Ups! Se perdió la señal de red",
    "up.noNetwork.pleaseCheck": "Por favor verifique la red, o vaya a",
    "up.noNetwork.connect": "Red conectada",
    "up.noNetwork.disconnect": "Sin conexión a internet",
    "up.pagination.previous": "Página anterior",
    "up.pagination.next": "Página siguiente",
    "up.pullRefresh.pull": "Deslizar hacia abajo para actualizar",
    "up.pullRefresh.release": "Soltar para actualizar",
    "up.pullRefresh.refreshing": "Actualizando",
    "up.readMore.expand": "Expandir para leer más",
    "up.readMore.fold": "Contraer",
    "up.search.placeholder": "Ingrese palabra clave",
    "up.signature.penSize": "Tamaño del trazo",
    "up.signature.penColor": "Color del trazo",
    "up.upload.sizeExceed": "Excede el límite de tamaño",
    "up.upload.uploading": "Subiendo",
    "up.upload.previewImageFail": "Error al previsualizar imagen",
    "up.upload.previewVideoFail": "Error al previsualizar vídeo",
    "up.goodsSku.stock": "Inventario",
    "up.goodsSku.price": "Precio",
    "up.goodsSku.amount": "Piezas",
    "up.goodsSku.choosed": "Seleccionado",
    "up.goodsSku.buyAmount": "Cantidad"
}
